
import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface HeroSectionProps {
  images: string[];
}

export default function HeroSection({ images }: HeroSectionProps) {
  const [showGallery, setShowGallery] = useState(false);

  return (
    <>
      <div className="relative h-[500px] bg-gray-100">
        <div className="grid grid-cols-4 gap-2 h-full p-2">
          <div className="col-span-2 row-span-2 relative overflow-hidden rounded-lg cursor-pointer group" onClick={() => setShowGallery(true)}>
            <img 
              src={images[0]} 
              alt="호텔 메인" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="relative overflow-hidden rounded-lg cursor-pointer group" onClick={() => setShowGallery(true)}>
            <img 
              src={images[1]} 
              alt="호텔 이미지" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="relative overflow-hidden rounded-lg cursor-pointer group" onClick={() => setShowGallery(true)}>
            <img 
              src={images[2]} 
              alt="호텔 이미지" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="relative overflow-hidden rounded-lg cursor-pointer group" onClick={() => setShowGallery(true)}>
            <img 
              src={images[3]} 
              alt="호텔 이미지" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="relative overflow-hidden rounded-lg cursor-pointer group" onClick={() => setShowGallery(true)}>
            <img 
              src={images[4]} 
              alt="호텔 이미지" 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>
        </div>
      </div>

      {showGallery && (
        <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
          <button 
            onClick={() => setShowGallery(false)}
            className="absolute top-4 right-4 text-white text-4xl z-10 w-12 h-12 flex items-center justify-center hover:bg-white/10 rounded-full transition-colors cursor-pointer"
          >
            <i className="ri-close-line"></i>
          </button>
          
          <div className="w-full max-w-5xl px-12">
            <Swiper
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true }}
              className="w-full"
            >
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <div className="w-full h-[80vh] flex items-center justify-center">
                    <img 
                      src={image} 
                      alt={`호텔 이미지 ${index + 1}`}
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
}
